// src/components/StoryOverlay.jsx
import React, { useEffect, useState } from 'react';
import '../css/StoryOverlay.css';

export default function StoryOverlay({ open, onClose, src = '/stories/mint-town.html' }) {
  const [html, setHtml] = useState('');

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const controller = new AbortController();
    const url = `${src}?v=${Date.now()}`;
    fetch(url, { signal: controller.signal })
      .then(res => res.text())
      .then(setHtml)
      .catch(() => setHtml('<article><h1>読み込みエラー</h1><p>後でもう一度お試しください。</p></article>'));

    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);

    return () => {
      controller.abort();
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, src, onClose]);

  if (!open) return null;

  return (
    <div className="story-overlay" aria-modal="true" role="dialog">
      {/* backdropは削除 */}
      <button className="story-close" aria-label="閉じる" onClick={onClose}>×</button>
      <div className="story-panel" role="document">
        <div className="story-content" dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </div>
  );
}
// export default function StoryOverlay({ open, onClose, src = '/stories/mint-town.html' }) {
//   const [html, setHtml] = useState('');

//   useEffect(() => {
//     if (!open) return;
//     // スクロール固定
//     const prev = document.body.style.overflow;
//     document.body.style.overflow = 'hidden';

//     const controller = new AbortController();
//     const url = `${src}?v=${Date.now()}`; // キャッシュバスター
//     fetch(url, { signal: controller.signal })
//       .then(res => res.text())
//       .then(setHtml)
//       .catch(() => setHtml('<article><h1>読み込みエラー</h1><p>後でもう一度お試しください。</p></article>'));

//     // ESCで閉じる
//     const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
//     window.addEventListener('keydown', onKey);

//     return () => {
//       controller.abort();
//       window.removeEventListener('keydown', onKey);
//       document.body.style.overflow = prev;
//     };
//   }, [open, src, onClose]);

//   if (!open) return null;

//   return (
//     <div className="story-overlay" aria-modal="true" role="dialog">
//       <div className="story-backdrop" onClick={onClose} />
//       <div className="story-panel" role="document">
//         <button className="story-close" aria-label="閉じる" onClick={onClose}>×</button>
//         <div
//           className="story-content"
//           dangerouslySetInnerHTML={{ __html: html }}
//         />
//       </div>
//     </div>
//   );
// }
